/*
$.mobileStickyNav();
takes a navigation bar (#mobile-sticky-nav) and once it scrolls out of view it moves to
fixed and off canvas. scrolling up brings it on the canvas scrolling
down hides it from the canvas.
*/

(function ($) {
    function mobileStickyNav() {
        var maxWidth = 767;

        evo.$.stickyNav = $('#mobile-sticky-nav');

        if (evo.$.stickyNav.length === 0) {
            return false;
        }

        var isFixed = false,
            isOffCanvas = false,
            navOffset = evo.$.stickyNav.offset().top,
            navStickyPoint = navOffset + (evo.$.stickyNav.height() * 2), //give it a little space to kick in.
            winWidth = evo.$.window.width(),
            prevScrollPosition = 0,
            currentScrollPosition = 0;

        if (winWidth <= maxWidth) {
            evo.$.window.on('scroll.stickyNav', function () {
                currentScrollPosition = $(this).scrollTop();
                if (currentScrollPosition > navStickyPoint) {
                    if (!isFixed) {
                        var t = setTimeout(function () {
                            evo.$.body.addClass('sticky-navigation');
                            isFixed = true;
                        }, 280);  //do it with a little time out so we don't get a flicker
                    }

                    if (currentScrollPosition > prevScrollPosition) {
                        if (!isOffCanvas) {
                            evo.$.body.addClass('sticky-off-canvas');
                            isOffCanvas = true;
                        }
                    }
                    else if (currentScrollPosition < prevScrollPosition) {
                        if (isOffCanvas) {
                            evo.$.body.removeClass('sticky-off-canvas');
                            isOffCanvas = false;
                        }
                    }
                }
                else if (currentScrollPosition <= navOffset) {
                    evo.$.body.removeClass('sticky-off-canvas');
                    if (isFixed) {
                        evo.$.body.removeClass('sticky-navigation');
                        isFixed = false;
                    }
                }

                else {
                    //do nothing
                }
                prevScrollPosition = currentScrollPosition;
            });
        }
    };

    $(function () {
        mobileStickyNav();
        evo.$.body.on('refresh.results', mobileStickyNav);
    });
})(jQuery);